import './monthlyForm.scss';

import { format } from 'date-fns';
import * as React from 'react';
import { connect, DispatchProp } from 'react-redux';
import { actions } from 'react-redux-form';
import { withRouter } from 'react-router';
import { toast } from 'react-toastify'; 
import * as PropTypes from 'prop-types'; 
import { SIGNATURE_ERROR, questionData } from '../../../constants/generals';
import { IHistory } from '../../../interfaces';
import { QuestionModel } from '../../../model/QuestionModel';
import { uploadImages } from '../../../services/formService';
import { parseJwt } from '../../../services/loginService';
import {
    getMonthlyFormQuestions,
    submitMonthlyForm,
} from '../../../services/monthlyFormService';
import { dispatch, marshallAnswers, checkAnswerForYesOrNo, getPageTitle, } from '../../../utils/generalUtils';
import { Async } from '../../reusableComponents/Async';
import { BasePage } from '../../reusableComponents/BasePage';
import { CustomSignaturePad } from '../../reusableComponents/CustomSignaturePad';
import { ErrorPage } from '../../reusableComponents/ErrorPage';
import { Form } from '../../reusableComponents/FormComponents/Form';
import { FormFooter } from '../../reusableComponents/FormComponents/FormFooter';
import { ImageUpload } from '../../reusableComponents/ImageUpload';
import { Loader } from '../../reusableComponents/Loader';
import { MonthlyFormModel } from '../../../model/MonthlyFormModel';
import { RenderQuestion } from '../../reusableComponents/FormComponents/RenderQuestion';
import { MonthlySWData } from '../../../constants/generals';

export interface IMonthlySWFormProps extends DispatchProp<any> {
    questions: QuestionModel[];
    type: string;
    date: string;
    formId: string;
    userName: string;
    plantId: string;
    userUID: string;
    history: IHistory;
    formInstance: MonthlyFormModel;
    form;
}

export interface IMonthlySWFormState {
    date: string;
    isTouched: boolean;
}

export class MonthlySWFormImpl extends React.Component<IMonthlySWFormProps, IMonthlySWFormState> {
    constructor(props: IMonthlySWFormProps) {
        super(props);
        this.state = {
            date: props.date, isTouched: false
        };
    }

    promise = async () => {
        const { formId, type } = this.props;
        await getMonthlyFormQuestions(type, formId);
    }

    static defaultProps: IMonthlySWFormProps;

    refs: {
        signatureInput: CustomSignaturePad;
        images: ImageUpload;
    };
    getChildContext() {
        return { formModel: 'forms.monthlySWForm' };
    } 

    static childContextTypes = {
        formModel: PropTypes.string
    };

    loadDefaultValues = () => {
        if (this.props.formId) {
            this.props.questions.forEach(instance => {
                dispatch(actions.change(`forms.monthlySWForm.${instance.props.quesNum}`,
                    checkAnswerForYesOrNo(instance.props.answer)));
            });
        }
    }

    handleFormSubmit = async (values) => {
        if (!this.refs.signatureInput.signature) {
            toast.error(SIGNATURE_ERROR, {
                position: toast.POSITION.TOP_CENTER,
                className: 'failed-toast'
            });
            return;
        } 
        //const signatureURL = await uploadImages([this.refs.signatureInput.signature], 'signatures'); 
        const answer = marshallAnswers(values, 'MonthlySW');
        answer.push({ /* quesNum: answer.length + 1, */ quesNum: 61, answer: format(new Date(), 'hh:mm A') }); 
        const data = {
            UserId: this.props.userUID,
            PlantId: this.props.plantId,
            InspectionID: 'MonthlySW',
            followUp_Required: false,
            Completed: true,
            Date: format(new Date(this.props.date), 'MM-DD-YYYY'),
            Answers: answer,
            followUp_form: 0,
            ImageUrls: [],
            DeletedImages : this.props.form.monthlySWForm.deletedImages || [],
            SignatureUrls: '',
            AssociatedTo: null,
            SignatureData: this.refs.signatureInput.signature, 
        };  
        //if(!this.props.formId) 
            return submitMonthlyForm(data, this.props.history, this.refs.images.value, this.props.formId);
    }

    loadValues = () => {
        this.loadDefaultValues();
        if (this.props.questions[2] && (this.props.questions[2].props.answer || '').toString() === 'Yes') {
            dispatch(actions.change(`forms.monthlySWForm.${4}`,
                format(this.props.questions[3].props.answer.toString(), 'MM/DD/YYYY')));
        }
        if (this.props.questions[4] && (this.props.questions[4].props.answer || '').toString() === 'Yes') {
            dispatch(actions.change(`forms.monthlySWForm.${6}`,
                format(this.props.questions[5].props.answer.toString(), 'MM/DD/YYYY')));
        }
    }

    renderContent = () => {
        const Buttons = [{
            label: 'Yes',
            value: 'Yes'
        },
        {
            label: 'No',
            value: 'No'
        },
        {
            label: 'N/A',
            value: 'N/A'
        }
        ]; 
        return <Form
            model="forms.monthlySWForm"
            onSubmit={this.handleFormSubmit}
            loadDefaultValues={this.loadValues}
            className="form">

            {MonthlySWData && MonthlySWData.map((quesData, index) => ( 
                <RenderQuestion
                    formId={this.props.formId}
                    key={index}
                    uniqueValue={index}
                    quesNo={quesData.Question_Num && quesData.Question_Num.toString()}
                    question={quesData.Question}
                    questionType={quesData.Questiontype}
                    model="monthlySWForm"
                    customLabel={quesData.customLabel && quesData.customLabel}
                    CommentQuestionLabel={quesData.CommentQuestionLabel ? quesData.CommentQuestionLabel : ''}
                    containsComment={quesData.containsComment ? true : false}
                    CommentQuestion={quesData.CommentQuestion ? quesData.CommentQuestion : ''}
                    CommentQuestionNum={quesData.CommentQuestionNum ? quesData.CommentQuestionNum : null}
                    buttons={Buttons}
                /> 
            ))
            }
            <div style={{ padding: '45px', fontSize: '18px' }} >
                I certify under penalty of law that this document and all attachments were
    prepared under my direction or supervision in accordance with a system designed to
    assure that qualified personnel properly gathered and evaluated the information
    submitted. Based on my inquiry of the person or persons who manage the system, or those
    persons directly responsible for gathering the information, the information submitted
    is, to the best of my knowledge and belief, true, accurate, and complete. I am
    aware that there are significant penalties for submitting false information,
    including the possibility of fine and imprisonment for knowing violations.
            </div>
            <div className="image-signature-container" >
                <ImageUpload
                    ref="images"
                    multi={true}
                    label="Select Images to Upload:" 
                    defaultValue={this.props.formInstance && this.props.formInstance.props.ImageUrls }
                />
                <CustomSignaturePad ref="signatureInput" userName={this.props.userName} />
            </div>
            <FormFooter />
        </Form>;

    }
    render() {
        let pageTitle = `${getPageTitle(this.props.type, 'monthly', this.props.date, 'inspection')} `;
        return < BasePage pageTitle={pageTitle} >
            <Async
                identifier="MonthlyForm"
                promise={this.promise}
                content={this.renderContent()}
                loader={<Loader type="async" />}
                error={<ErrorPage />}
            />
        </BasePage>;
    }
}

export function mapStateToProps(state, ownProps) {
    const type = 'MonthlySW';
    const date = ownProps.match.params.date;
    const questions = QuestionModel.getAllByType(type);
    const userName = parseJwt(state.login.get('token')).First_Name;
    const formId = ownProps.match.params.formId;
    const formInstance = MonthlyFormModel.get(formId); 
    return {
        plantId: ownProps.match.params.plantId,
        userUID: state.login.get('UniqueId'),
        questions, type: 'MonthlySW', date, userName,
        formId,form: state.forms, formInstance
    };
}

export const MonthlySWForm = withRouter(connect<{}, {}, IMonthlySWFormProps>(mapStateToProps)(MonthlySWFormImpl));



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Forms/MonthlyForm/MonthlySWForm.tsx